export default __webpack_public_path__ + "static/media/slacklogo.e971fd7d.svg";